import { ReactComponent as IconBiowaste } from "../../../static/assets/biowaste.svg";
import { ReactComponent as IconWood } from "../../../static/assets/wood.svg";
import { ReactComponent as IconMineral } from "../../../static/assets/mineral.svg";
import { ReactComponent as IconMetal } from "../../../static/assets/metal.svg";
import { ReactComponent as IconCardboard } from "../../../static/assets/cardboard.svg";
import { ReactComponent as IconPlastic } from "../../../static/assets/plastic.svg";
import { ReactComponent as IconPlaster } from "../../../static/assets/plaster.svg";
import { ReactComponent as IconTextil } from "../../../static/assets/textil.svg";
import { ReactComponent as IconGlass } from "../../../static/assets/glass.svg";
import { ReactComponent as IconAuther } from "../../../static/assets/auther.svg";

const CATEGORY_ICON_COMPONENTS = {
  biowaste: IconBiowaste,
  wood: IconWood,
  mineral: IconMineral,
  metal: IconMetal,
  cardboard: IconCardboard,
  plastic: IconPlastic,
  plaster: IconPlaster,
  textile: IconTextil,
  glass: IconGlass,
  other: IconAuther,
};

export function getCategoryIconComponent(parentCategory) {
  return CATEGORY_ICON_COMPONENTS[parentCategory] || IconAuther;
}
